import * as React from "react";
import useD365Form from "../../../hooks/d365-form/use-d365-form";

function HiddenEmailForm() {
  useD365Form({ formId: "10910749-f6a5-ef11-8a69-7c1e5201d6b5" });

  return (
    <div style={{ display: "none" }}>
      <div data-form-block-id="10910749-f6a5-ef11-8a69-7c1e5201d6b5" />
      <script src="https://mktdplp102cdn.azureedge.net/public/latest/js/form-loader.js?v=1.84.2007" />
      <div id="d_7q4QGudQhz5gAtUSaPdFBLqvrTbEkHYqgQVIwV0cso" />
      <script src="https://mktdplp102cdn.azureedge.net/public/latest/js/ws-tracking.js?v=1.84.2007" />
      <div
        className="d365-mkt-config"
        style={{ display: "none" }}
        data-website-id="_7q4QGudQhz5gAtUSaPdFBLqvrTbEkHYqgQVIwV0cso"
        data-hostname="2a768ee8dd2f4342b33eafb283a2318a.svc.dynamics.com"
      />
    </div>
  );
}

export default HiddenEmailForm;
